<!-- Ported from the Polaris kit: src/product/components/StatTile.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand change (phase P, 28/09): the info button's name ("About {label}") goes through i18n. The kit has no
     variation arrow (7-9: that waits for the kit); `hint` carries it in words meanwhile. -->
<script setup>
// One number with its label. A dash when there is nothing to show yet, never a zero that was not measured. `loading` keeps its place with a
// skeleton; `info` explains the measure in a tooltip, on a button that is named for it.
import { useI18n } from 'vue-i18n';
import { Information16 } from '@carbon/icons-vue';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Skeleton } from '../ui/skeleton';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

defineProps({
  label: { type: String, required: true },
  value: { type: String, default: '-' }, // already formatted: "1,204", "92%", "3m 20s"
  hint: { type: String, default: '' },
  info: { type: String, default: '' },
  loading: Boolean,
});
const { t } = useI18n();
</script>

<template>
  <Card class="gap-0 py-4" data-stat-tile :aria-busy="loading || undefined">
    <CardContent class="grid gap-1 px-4">
      <p
        class="flex items-center gap-1 type-polaris-caption text-polaris-muted-foreground"
      >
        {{ label }}
        <Tooltip v-if="info">
          <TooltipTrigger as-child>
            <Button
              type="button"
              variant="ghost"
              size="icon-sm"
              class="size-6 text-polaris-muted-foreground"
              :aria-label="t('POLARIS.STAT_TILE.ABOUT', { label })"
            >
              <Information16 aria-hidden="true" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{{ info }}</TooltipContent>
        </Tooltip>
      </p>
      <Skeleton v-if="loading" class="h-9 w-20" />
      <p v-else class="type-polaris-display">{{ value }}</p>
      <p v-if="hint" class="type-polaris-caption text-polaris-muted-foreground">
        {{ hint }}
      </p>
    </CardContent>
  </Card>
</template>
